import type { CachedLocation } from '@sda/utils/location/interfaces';
import type { DateTime } from 'luxon';
import type { DateRange } from '@mui/x-date-pickers-pro';
import type { ProfileTypes } from '@sda/enums';
import type { AlgoliaIndices } from '@sda/enums/algolia';
import type { AlgoliaBeacon, GeolocHit } from '@sda/helpers/algolia.helpers';

export enum FilterOptions {
  ALL = 'ALL',
  FEATURED = 'FEATURED',
  EXPERIENCED = 'EXPERIENCED',
  PARTNER = 'PARTNER',
}

export enum RequiresPAOptions {
  ALL = 'ALL',
  YES = 'YES',
  NO = 'NO',
}

export enum PinTypes {
  SHOWCALLS = 'SHOWCALLS',
  PROFILES = 'PROFILES',
}

export interface FilterFormValues extends CachedLocation {
  indexName: AlgoliaIndices;
  filter: FilterOptions[];
  venueType: string[];
  searchType: ProfileTypes;
  dateRange: DateRange<DateTime>;
  hasPA: boolean;
  primaryGenre: string[];
  requiresPA: RequiresPAOptions[];
}

export interface ShowCallResults {
  readonly nbHits: number;
  readonly isLoaded: boolean;
  readonly hits: GeolocHit<AlgoliaBeacon>[];
}
